import styled from "styled-components";

interface StyledImageProps {
  hasTopMargin: boolean;
}

export const StyledImage = styled.div<StyledImageProps>`
  margin-top: ${({hasTopMargin}) => hasTopMargin ? "13rem" : "0"};
  margin-bottom: -1rem;

  &.collection-styled-image { 
    margin-bottom: 0;
    margin-top: 0rem;
  }

  @media ${({ theme }) => theme.device.tablet} {
    margin-top: ${({hasTopMargin}) => hasTopMargin ? "11rem" : "0"};

    &.collection-styled-image { 
      margin-bottom: 0;
      margin-top: 0.5rem;
    }
  }
`;

export const DesktopImage = styled.div`
  display: none;

  @media ${({ theme }) => theme.device.tablet} {
    display: block;
    .gatsby-image-wrapper {
      width: 100%;
      display: block !important;
    }
  }
`;

export const MobileImage = styled.div`
  display: block;
  .gatsby-image-wrapper {
    display: block !important;
  }

  @media ${({ theme }) => theme.device.tablet} {
    display: none;
  }
`;

